import { getUniqueColor } from "./unique-color";

export const ProviderColors = {
    "aivax": "#6f6ee8",
    "amazon": "#ff9900",
    "anthropic": "#d17458",
    "bytedance": "#ff4d4f",
    "cognitivecomputations": "#8a5cf6",
    "cohere": "#39b98f",
    "deepseek": "#4f8cff",
    "deepseekai": "#4f8cff",
    "dolphin": "#22a8c7",
    "google": "#4285f4",
    "groq": "#f55036",
    "gryphe": "#b76ee8",
    "inception": "#2aa9a1",
    "kwaipilot": "#9ec0e0",
    "meta": "#0668e1",
    "metaai": "#0668e1",
    "microsoft": "#00a4ef",
    "minimax": "#ea5b9c",
    "mistral": "#fa6b2b",
    "model-router": "#7c5cff",
    "moonshotai": "#6c7cff",
    "nous-research": "#be6df2",
    "nvidia": "#76b900",
    "openai": "#10a37f",
    "particle-ai": "#ffb000",
    "perplexity": "#20b8c9",
    "poolside": "#4137ff",
    "qwen": "#6b8cff",
    "rekaai": "#f05d7f",
    "tencent": "#006eff",
    "venice": "#e45f93",
    "x-ai": "#4b82f0",
    "xiaomi": "#ff6900",
    "z-ai": "#ef4b4f",
    "unknown": "#8b5cf6"
};

export function getProviderKey(providerOrModel) {
    const provider = providerOrModel?.toString()?.split('/')[0] ?? "unknown";

    return provider.replace(/^@/, '').toLowerCase() || "unknown";
}

export function getProviderColor(providerOrModel) {
    const providerKey = getProviderKey(providerOrModel);

    return ProviderColors[providerKey] ?? getUniqueColor(providerKey);
}
